import React from 'react';
import { Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Header from '../Layouts/Header';
import { Link } from 'react-router-dom';
import Page from '../Components/Page';
import { useScrollToTop } from '../Utils/ScrollToTop';

const useStyles = makeStyles((theme)=> ({
    copy: {
        textAlign: "center",
        maxWidth: "600px",
        margin: "auto",
        padding: theme.spacing(2),
        "& a": {
            color: theme.palette.primary.main,
        }
    },
}));

const NotFound = () => {
    const classes = useStyles();
    
    useScrollToTop();

    return (
        <Page title="Page not found">
            <Header style={{paddingBottom: "1rem"}} />
            <Typography variant="body1" component="div" className={classes.copy}>
                <p>
                    This page is not currently available.  Please use the following links to take you to the main pages 
                    of <Link to="/">BAFTA View</Link> and <a href="https://voting.bafta.org/" target="_blank" rel="noreferrer">BAFTA Voting</a>.
                </p>
                <p>
                    If you have any questions please use the help link below or 
                    contact <a href="mailto:voting@bafta.org">voting@bafta.org</a>.
                </p>
            </Typography>
        </Page>
    );
};

export default NotFound;